import { palette } from "lib/miolo";
import FundamentalsChartContext from "components/fundamentals/FundamentalsChartContext";
import { Fundaments } from "components/fundamentals/Fundaments";
import FundamentToggle from "components/fundamentals/FundamentToggle";

export default function InsurerFundamentalsToggles() {
  return (
    <FundamentalsChartContext.Consumer>
      {({ fundaments, selectableFundaments, toggle, selectOnly }) => (
        <>
          <FundamentToggle
            labelText="Patrim. Líq."
            labelTextColor={palette.kumera}
            backgroundColor={palette.linen}
            isActive={fundaments.includes(Fundaments.NET_EQUITY)}
            onClick={() => toggle(Fundaments.NET_EQUITY)}
            onDoubleClick={() => selectOnly(Fundaments.NET_EQUITY)}
          />

          <FundamentToggle
            labelText="Receita Líq."
            labelTextColor={palette.fruitSalad}
            backgroundColor="#EEFBEF"
            isActive={fundaments.includes(Fundaments.NET_REVENUE)}
            onClick={() => toggle(Fundaments.NET_REVENUE)}
            onDoubleClick={() => selectOnly(Fundaments.NET_REVENUE)}
          />

          <FundamentToggle
            labelText="EBITDA"
            labelTextColor={palette.seaGreen}
            backgroundColor="#EEFBEF"
            isActive={fundaments.includes(Fundaments.EBITDA)}
            onClick={() => toggle(Fundaments.EBITDA)}
            onDoubleClick={() => selectOnly(Fundaments.EBITDA)}
          />

          <FundamentToggle
            labelText="Lucro Líq."
            labelTextColor={palette.oceanGreen}
            backgroundColor="#EEFBEF"
            isActive={fundaments.includes(Fundaments.NET_INCOME)}
            onClick={() => toggle(Fundaments.NET_INCOME)}
            onDoubleClick={() => selectOnly(Fundaments.NET_INCOME)}
          />

          <FundamentToggle
            labelText="Mrg. Líq."
            labelTextColor="#507712"
            backgroundColor="#EEFBEF"
            isActive={fundaments.includes(Fundaments.NET_MARGIN)}
            onClick={() => toggle(Fundaments.NET_MARGIN)}
            onDoubleClick={() => selectOnly(Fundaments.NET_MARGIN)}
          />

          {selectableFundaments.includes(Fundaments.RETURN_ON_EQUITY) && (
            <FundamentToggle
              labelText="ROE"
              labelTextColor={palette.stromboli}
              backgroundColor="#EEFBEF"
              isActive={fundaments.includes(Fundaments.RETURN_ON_EQUITY)}
              onClick={() => toggle(Fundaments.RETURN_ON_EQUITY)}
              onDoubleClick={() => selectOnly(Fundaments.RETURN_ON_EQUITY)}
            />
          )}

          <FundamentToggle
            labelText="Caixa"
            labelTextColor={palette.dixie}
            backgroundColor="#FCF4F4"
            isActive={fundaments.includes(Fundaments.CASH)}
            onClick={() => toggle(Fundaments.CASH)}
            onDoubleClick={() => selectOnly(Fundaments.CASH)}
          />

          {selectableFundaments.includes(Fundaments.DEBT) && (
            <FundamentToggle
              labelText="Div. Bruta"
              labelTextColor={palette.burntUmber}
              backgroundColor="#FCF4F4"
              isActive={fundaments.includes(Fundaments.DEBT)}
              onClick={() => toggle(Fundaments.DEBT)}
              onDoubleClick={() => selectOnly(Fundaments.DEBT)}
            />
          )}

          {selectableFundaments.includes(Fundaments.NET_DEBT) && (
            <FundamentToggle
              labelText="Div. Líq."
              labelTextColor={palette.mojo}
              backgroundColor="#FCF4F4"
              isActive={fundaments.includes(Fundaments.NET_DEBT)}
              onClick={() => toggle(Fundaments.NET_DEBT)}
              onDoubleClick={() => selectOnly(Fundaments.NET_DEBT)}
            />
          )}

          <FundamentToggle
            labelText="FCO"
            labelTextColor={palette.tundora}
            backgroundColor={palette.lilyWhite}
            isActive={fundaments.includes(Fundaments.CASH_FLOW_FROM_OPERATIONS)}
            onClick={() => toggle(Fundaments.CASH_FLOW_FROM_OPERATIONS)}
            onDoubleClick={() => selectOnly(Fundaments.CASH_FLOW_FROM_OPERATIONS)}
          />

          <FundamentToggle
            labelText="FCL CAPEX"
            labelTextColor={palette.scienceBlue}
            backgroundColor={palette.lilyWhite}
            isActive={fundaments.includes(Fundaments.FREE_CASH_FLOW)}
            onClick={() => toggle(Fundaments.FREE_CASH_FLOW)}
            onDoubleClick={() => selectOnly(Fundaments.FREE_CASH_FLOW)}
          />

          {selectableFundaments.includes(Fundaments.CASH_FLOW_FOR_DIVIDENDS) && (
            <FundamentToggle
              labelText="Proventos"
              labelTextColor={palette.luxorGold}
              backgroundColor="#FCF9F0"
              isActive={fundaments.includes(Fundaments.CASH_FLOW_FOR_DIVIDENDS)}
              onClick={() => toggle(Fundaments.CASH_FLOW_FOR_DIVIDENDS)}
              onDoubleClick={() => selectOnly(Fundaments.CASH_FLOW_FOR_DIVIDENDS)}
            />
          )}

          <FundamentToggle
            labelText="Payout"
            labelTextColor="#CB6E17"
            backgroundColor="#FCF9F0"
            isActive={fundaments.includes(Fundaments.PAYOUT)}
            onClick={() => toggle(Fundaments.PAYOUT)}
            onDoubleClick={() => selectOnly(Fundaments.PAYOUT)}
          />
        </>
      )}
    </FundamentalsChartContext.Consumer>
  );
}
